<template>
  <div>
    <as-dialogo ref="dialogoNovoUsuario" title="Novo Usuário" max-width="800px">
      <v-form ref="form" v-model="form" lazy-validation>
        <v-container grid-list-lg fluid>
          <v-layout row wrap align-center>
            <v-flex sm6>
              <v-radio-group
                v-model="novo_user.tipo"
                class="mt-0"
                :rules="rules.tipo"
              >
                <v-layout v-if="!cadastroCliente" row wrap mb-1>
                  <v-flex xs3 pr-2>
                    <img style="width: 100%;" src="img/briefcase.svg" />
                  </v-flex>
                  <v-flex xs9>
                    <v-radio
                      color="primary"
                      class="black--text"
                      label="Representante"
                      value="representante"
                    ></v-radio>
                    <div
                      style="font-size: small; padding-left: 32px; padding-right: 8px"
                    >
                      Esta conta é somente indicada para representações
                      comerciais
                    </div>
                  </v-flex>
                </v-layout>

                <v-layout v-if="!cadastroCliente" row wrap mb-1>
                  <v-flex xs3>
                    <img style="width: 100%;" src="img/shirt.svg" />
                  </v-flex>
                  <v-flex xs9>
                    <v-radio
                      color="primary"
                      label="Fornecedor"
                      value="fornecedor"
                    ></v-radio>
                    <div
                      style="font-size: small; padding-left: 32px; padding-right: 8px"
                    >
                      Se você é fabricante ou revendedor de produtos no atacado
                      esta é a sua conta
                    </div>
                  </v-flex>
                </v-layout>

                <v-layout row wrap>
                  <v-flex xs3>
                    <img style="width: 100%;" src="img/online-shop.svg" />
                  </v-flex>
                  <v-flex xs9>
                    <v-radio
                      color="primary"
                      label="Cliente"
                      value="cliente"
                    ></v-radio>
                    <div
                      style="font-size: small; padding-left: 32px; padding-right: 8px"
                    >
                      Para comerciantes e lojistas em geral, esta conta vai
                      conectar você aos melhores fornecedores e representações
                      do mercado
                    </div>
                  </v-flex>
                </v-layout>
              </v-radio-group>
            </v-flex>
            <v-flex sm6>
              <v-text-field
                v-model="novo_user.nome"
                ref="nome"
                color="primary"
                label="Nome"
                :rules="rules.nome"
                placeholder="Digite seu nome"
                persistent-placeholder
                autocomplete="off"
                role="presentation"
              ></v-text-field>
              <v-text-field
                v-model="novo_user.email"
                ref="email"
                @change="limparErroEmail"
                color="primary"
                label="Email"
                :rules="rules.email"
                :error="errors.email.length > 0"
                :error-messages="errors.email"
                placeholder="Digite seu email"
                persistent-placeholder
                autocomplete="off"
                role="presentation"
              ></v-text-field>
              <v-text-field
                v-model="novo_user.password"
                ref="senha"
                color="primary"
                label="Senha"
                type="password"
                :rules="rules.password"
                placeholder="Digite uma senha"
                persistent-placeholder
                autocomplete="off"
                role="presentation"
              ></v-text-field>
              <v-text-field
                v-model="novo_user.confirm_password"
                ref="confirmar_senha"
                color="primary"
                type="password"
                label="Confirmar Senha"
                :rules="rules.confirmPassword"
                placeholder="Confirme sua senha"
                persistent-placeholder
                autocomplete="off"
                role="presentation"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
      <div slot="botoes" style="text-align: right">
        <v-btn
          depressed
          class="mx-4 my-2"
          @click="$refs.dialogoNovoUsuario.fechar()"
          >Cancelar</v-btn
        >
        <v-btn
          depressed
          color="primary"
          class="mx-4 my-2 ml-2"
          :loading="loading"
          :disabled="!form"
          @click="abrirTermos"
          >Cadastrar</v-btn
        >
      </div>
    </as-dialogo>

    <as-dialogo
      ref="dialogoSalvando"
      title="Aguarde..."
      max-width="600px"
      hideCloseButton
    >
      <v-label class="ma-auto" style="margin-top: 12px"
        >Só um momento, estamos criando sua conta</v-label
      >
    </as-dialogo>

    <termos-uso ref="dialogoTermosUso" @success="salvarUsuario" />
  </div>
</template>

<script>
import TermosUso from "@/views/login/TermosUso.vue";

import config from "@/config";
import ServicesUsers from "@/services/users.js";

export default {
  name: "NovoUsuario",
  props: {
    cadastroCliente: {
      type: Boolean,
      default: true,
    },
  },
  components: { TermosUso },
  data() {
    return {
      form: true,
      loading: false,
      novo_user: {
        tipo: "",
        nome: "",
        email: "",
        password: "",
        confirm_password: "",
        termos: false,
      },
      rules: {
        nome: [
          (v) => !!v || "Campo obrigatório",
          (v) =>
            (v && v.length > 2) || "O nome deve ter no mínimo 3 carecteres",
        ],
        email: [
          (v) => !!v || "Campo obrigatório",
          (v) => /.+@.+/.test(v) || "Email inválido",
        ],
        password: [(v) => !!v || "Campo obrigatório"],
        confirmPassword: [
          (v) => !!v || "Campo obrigatório",
          (v) => v == this.novo_user.password || "As senhas devem ser iguais",
        ],
        tipo: [(v) => !!v],
      },
      errors: {
        email: [],
      },
    };
  },
  methods: {
    abrir() {
      this.$refs.dialogoNovoUsuario.abrir();
      if (this.cadastroCliente) {
        this.novo_user.tipo = "cliente";
      } else {
        this.novo_user.tipo = "";
      }
    },
    abrirTermos() {
      if (this.$refs.form.validate()) {
        this.$refs.dialogoTermosUso.abrir();
      }
    },
    async salvarUsuario() {
      this.loading = true;
      this.novo_user.termos = true;
      this.$refs.dialogoTermosUso.fechar();
      this.$refs.dialogoNovoUsuario.fechar();
      this.$refs.dialogoSalvando.abrir();
      try {
        let user = await ServicesUsers.newUser(this.novo_user);
        this.$refs.dialogoSalvando.fechar();
        this.$emit("success", {
          email: this.novo_user.email,
          password: this.novo_user.password,
        });
        this.novo_user = {
          tipo: "",
          nome: "",
          email: "",
          password: "",
          confirm_password: "",
          termos: false,
        };
      } catch (error) {
        this.$refs.dialogoSalvando.fechar();
        this.$refs.dialogoNovoUsuario.abrir();
        this.$eventbus.erro("Erro ao cadastrar usuário");
        if (error.response.data) {
          if (typeof error.response.data.errors.email !== "undefined") {
            this.errors.email = error.response.data.errors.email;
          }
        }
        this.novo_user.termos = false;
      }
      this.loading = false;
    },
    limparErroEmail() {
      this.errors.email = "";
    },
  },
};
</script>

<style></style>
